/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import Icon from "react-icons-kit";
import { info } from "react-icons-kit/feather/info";

import { Text } from "UpduoLibrary";
import {
  colorWithOpacity,
  skaleBlack,
  skaleWhite,
  upduoPrimaryBlue,
} from "config/UpduoColors";

export interface DashboardWidgetProps {
  title: string;
}

export default function SessionInfoWidget({
  title,
  children,
}: React.PropsWithChildren<DashboardWidgetProps>) {
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "column",
        borderRadius: 12,
        shadowColor: colorWithOpacity(skaleBlack, 0.25),
        shadowRadius: 12,
        backgroundColor: skaleWhite,
        marginTop: 15,
        padding: 20,
        paddingBottom: 10,
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          marginBottom: 10,
        }}
      >
        <Text style={{ color: upduoPrimaryBlue, marginRight: 5 }}>
          <Icon size={14} icon={info} style={{ margin: "auto" }} />
        </Text>
        <Text style={{ fontSize: 12, fontWeight: "500", color: skaleBlack }}>
          {title}
        </Text>
      </View>
      {children}
    </View>
  );
}
